import type { TvChannelProgram } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

export const useLastCompletedChannelProgramId = (
    programs: readonly TvChannelProgram[] | undefined
): number | undefined =>
    programs?.find((_program, index, list) => {
        const nextProgram = list[index + 1];
        const currentTimeInMs = Date.now();

        if (!nextProgram) {
            return false;
        }

        if (nextProgram.startTime < currentTimeInMs && nextProgram.endTime > currentTimeInMs) {
            return true;
        }

        return false;
    })?.id;
